import { BaseModel } from './base.model';
import { Society } from './society.model';
import { System } from './system.model';

export interface Client {
    id: number;
    name: string;
    address: string;
    email: string;
    phonenumber: string;
    societies: Society[];
    systems: System[];
  }

  export class Client implements BaseModel {
    id: number;
    name: string;
    address: string;
    email: string;
    phonenumber: string;
    societies: Society[];
    systems: System[];

    constructor();
    constructor(id: number, name: string, address: string, email: string, phonenumber: string, societies: Society[], systems: System[]);

    constructor(id?: number, name?: string, address?: string, email?: string, phonenumber?: string, societies?: Society[], systems?: System[]) {
      if (id !== undefined) {
        this.id = id;
      }
      if (name !== undefined) {
        this.name = name;
      } else {
        this.name = '';
      }

      if (address !== undefined) {
        this.address = address;
      } else {
        this.address = '';
      }

      if (email !== undefined) {
        this.email = email;
      } else {
        this.email = '';
      }
      if (phonenumber !== undefined) {
        this.phonenumber = phonenumber;
      } else {
        this.phonenumber = '';
      }

      if (societies !== undefined) {
        this.societies = societies;
      } else {
        this.societies = [];
      }

      if (systems !== undefined) {
        this.systems = systems;
      } else {
        this.systems = [];
      }
    }

    getApiName(): string {
      return 'client';
    }

    getName(): string {
      return 'Cliente';
    }

    getNamePl(): string {
      return 'Clientes';
    }
  }